import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useSkillsState() {
  return useAppState();
}

export function useSkillsActions() {
  const dispatch = useAppDispatch();

  function initializeState(authenticatedUser) {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      authenticatedUser,
      pageNumber: 1,
      numberOfPages: 1,
      skills: [],
      newUnrecognizedSkillForm: {
        skillName: '',
        debouncedSkillNameForFuzzyFilter: '',
      },
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function updateNewSkillName(skillName) {
    dispatch((appState) => ({
      ...appState,
      newUnrecognizedSkillForm: {
        ...appState.newUnrecognizedSkillForm,
        skillName: skillName,
      },
    }));
  }

  function updateDebouncedSkillNameForFuzzyFilter(debouncedSkillNameForFuzzyFilter) {
    dispatch((appState) => ({
      ...appState,
      newUnrecognizedSkillForm: {
        ...appState.newUnrecognizedSkillForm,
        debouncedSkillNameForFuzzyFilter: debouncedSkillNameForFuzzyFilter,
      },
    }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    updateNewSkillName,
    updateDebouncedSkillNameForFuzzyFilter,
    getFeedbackFromLocalStorage,
    clearFeedback,
  };
}
